import type * as THREE from 'three'
import type { ExtendedWebGLRenderer, TextureProperties } from '@/plugins/gsplat/types/WebGLTypes'

export function syncTextureUploadVersion(
  renderer: THREE.WebGLRenderer,
  texture: THREE.Texture
): void {
  const extRenderer = renderer as ExtendedWebGLRenderer
  const properties = extRenderer.properties?.get(texture) as TextureProperties | undefined
  if (properties) {
    properties.__version = texture.version
  }

  const source = texture.source
  const sourceProperties = extRenderer.properties?.get(source) as TextureProperties | undefined
  if (sourceProperties) {
    sourceProperties.__version = source.version
  }
}
